module.exports = __webpack_public_path__ + "static/img/sgn-logo.90ee388.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sgn-logo.png
// module id = dzXE
// module chunks = 1